import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import MenuItem from '@mui/material/MenuItem';
import arimaLogo from '../../../image/arima_logos/arima-wordmark-white.png';
import { AUTH_ROUTES, LANDING_ROUTES } from '../../Utilities/routePaths';
import Button from '@styles/styledComponents/buttons';

function AccountHeader() {
  const history = useHistory();
  const matches = useMediaQuery('(min-width:1100px)');
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Header>
      <LeftContainer>
        <a href={LANDING_ROUTES.HOME}>
          <img
            src={arimaLogo}
            alt=''
            style={{ height: '35px', marginLeft: 10 }}
          />
        </a>
      </LeftContainer>
      <HeaderLinks>
        {matches ? (
          <>
            <a href={LANDING_ROUTES.ABOUT}>About</a>
            <Link to={AUTH_ROUTES.LOGIN}>Login</Link>
            <Button
              type='submit'
              text='Register'
              sx={{
                color: '#1C479C',
                backgroundColor: '#FFFFFF',
                fontSize: '16px',
                '&:hover': {
                  backgroundColor: '#FFFFFF',
                },
              }}
              onClick={() => history.push(AUTH_ROUTES.SIGN_UP)}
            />
          </>
        ) : (
          <IconButton
            style={{ color: 'white', marginTop: -11 }}
            onClick={handleClick}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Popover
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          style={{ zIndex: 5001 }}
        >
          <MenuItem
            onClick={() => (window.location.href = LANDING_ROUTES.ABOUT)}
          >
            About
          </MenuItem>
          <MenuItem onClick={() => history.push(AUTH_ROUTES.LOGIN)}>
            Login
          </MenuItem>
          <MenuItem onClick={() => history.push(AUTH_ROUTES.SIGN_UP)}>
            Register
          </MenuItem>
        </Popover>
      </HeaderLinks>
    </Header>
  );
}

export default AccountHeader;

const Header = styled('div')(({ theme }) => ({
  zIndex: 5000,
  position: 'fixed',
  top: 0,
  width: '100%',
  background: '#022140',
  minHeight: 64,
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'nowrap',
  padding: '0 8px',
}));

const LeftContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

const HeaderLinks = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: '16px',
  '& p, & a': {
    marginBottom: 0,
    color: 'white',
    marginRight: 40,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: '#ffc107',
    },
  },
}));
